import { Link } from 'react-router-dom';

export default function HomeFooter() {
  return (
    <footer className="bg-rose-950 text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <img
              src="https://static.readdy.ai/image/1b0e966215e432d351b2e9c11ca0b10e/154dcc8a65fed03ee4761cc080c3eddf.png"
              alt="EntreNós"
              loading="lazy"
              decoding="async"
              width="120"
              height="40"
              className="h-10 w-auto mb-4"
            />
            <p className="text-rose-200 text-sm">
              Fortalecendo conexões emocionais através de experiências personalizadas e IA
              especializada.
            </p>
          </div>
          <div>
            <h4 className="font-bold mb-4 text-rose-100">Produto</h4>
            <ul className="space-y-2 text-sm text-rose-300">
              <li>
                <a href="#como-funciona" className="hover:text-white transition-colors">
                  Como Funciona
                </a>
              </li>
              <li>
                <a href="#planos" className="hover:text-white transition-colors">
                  Planos
                </a>
              </li>

            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4 text-rose-100">Empresa</h4>
            <ul className="space-y-2 text-sm text-rose-300">
              <li>
                <Link to="/sobre" className="hover:text-white transition-colors">
                  Sobre
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4 text-rose-100">Legal</h4>
            <ul className="space-y-2 text-sm text-rose-300">
              <li>
                <Link to="/privacidade" className="hover:text-white transition-colors">
                  Privacidade
                </Link>
              </li>
              <li>
                <Link to="/termos" className="hover:text-white transition-colors">
                  Termos de Uso
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-rose-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-rose-300 text-sm">© 2026 EntreNós. Todos os direitos reservados.</p>
          <div className="flex items-center gap-3">
            <span className="text-rose-400 text-sm">Siga-nos:</span>
            <a
              href="https://www.tiktok.com/@conexaoentrenos"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center bg-rose-800 hover:bg-black rounded-full transition-colors cursor-pointer"
              title="TikTok @conexaoentrenos"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 text-white">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
